import { render, staticRenderFns } from "./editName.vue?vue&type=template&id=625ac478&scoped=true&"
import script from "./editName.vue?vue&type=script&lang=js&"
export * from "./editName.vue?vue&type=script&lang=js&"
import style0 from "./editName.vue?vue&type=style&index=0&id=625ac478&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ac478",
  null
  
)

export default component.exports